
import IframeResizer from 'iframe-resizer-react'
import React, { useEffect, useState } from 'react'

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Modal } from 'antd';

import { RootState } from '@share/utils';
import { ILoginState } from '@share/store/slices';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMaximize } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

export function IframeBackoffice() {

  const iframeRef: React.RefObject<HTMLIFrameElement> = React.createRef();
  const divContainer: React.RefObject<HTMLDivElement> = React.createRef();

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [iFrameKey, _setIFrameKey] = useState(new Date().getTime());
  const [iFrameKeyFullScreen, setIFrameKeyFullScreen] = useState(new Date().getTime());

  const loginStore: ILoginState = useSelector((state: RootState) => state.loginStore);

  const token = loginStore?.user?.accessToken;

  const iframeOrigin = import.meta.env.VITE_API_BACKOFFICE_URL;
  const iframeSrc = `${iframeOrigin}/signin/${loginStore?.account?.name}/?accessToken=${token}`;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== iframeOrigin) {
        console.error('Message from untrusted origin:', event.origin);
        return;
      }
      const type = event.data.type;
      if (type === 'copy-to-clipboard') {
        navigator.clipboard.writeText(event.data.payload as string);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (!isEmpty(token)) {
    return (
      <div className="backoffice-iframe-container" ref={divContainer}>
        <div className="backoffice-iframe-container__header" onClick={() => {
          setIsFullScreen(true);
          setIFrameKeyFullScreen(new Date().getTime());
        }}>
          <FontAwesomeIcon icon={faMaximize} style={{ marginRight: '5px' }} />
          Full Screen
        </div>

        <IframeResizer
          forwardRef={iframeRef}
          heightCalculationMethod="lowestElement"
          id="backoffice_iframe"
          src={iframeSrc}
          style={{ width: '1px', minWidth: '100%'}}
          sandbox="allow-scripts allow-forms allow-same-origin allow-downloads allow-popups"
          key={iFrameKey}
        />

        <Modal
          open={isFullScreen}
          onCancel={() => {
            setIsFullScreen(false);
            setIFrameKeyFullScreen(new Date().getTime());
          }}
          footer={null}
          className="backoffice-iframe-container__modal"
          style={{ height: '100%', width: '100%' }}
          width="100%"
        >
          <IframeResizer
            forwardRef={iframeRef}
            heightCalculationMethod="lowestElement"
            id="backoffice_iframe"
            src={`${import.meta.env.VITE_API_BACKOFFICE_URL}/signin/${loginStore?.account?.name}/?accessToken=${token}`}
            style={{ width: '1px', minWidth: '100%'}}
            sandbox="allow-scripts allow-forms allow-same-origin allow-downloads allow-popups"
            key={iFrameKeyFullScreen}
          />
        </Modal>
      </div>
    );
  }

  return (<div><FormattedMessage id="you.are.not.authorized" /></div>);
}
